import HStack from "@/pages/taskpane/components/layout/HStack";
import TitleSetting from "@/pages/taskpane/components/ui/TitleSetting";
import { useAppConfigStore, useThemeStore } from "@/pages/taskpane/shared/stores";
import React, { useCallback, useState } from "react";
import Accordion from "@/pages/taskpane/components/ui/Accordion";
import { settingLabels } from "@/pages/taskpane/shared/constants/setting";
import Divider from "@/pages/taskpane/components/ui/Divider";
import Button from "@/pages/taskpane/components/ui/Button";
import { handleOpenDialog } from "@/pages/taskpane/lib/utils/handleOpenDialog";
import { usePlatform, WebAddinPlatforms } from "@/pages/taskpane/shared/hooks/usePlatform";
import { useTranslation } from "react-i18next";
import { QuestionCircleIcon } from "@/pages/taskpane/components/icons/IconCustom";

const HelpSetting = () => {
  const { t } = useTranslation();
  const { isDarkMode } = useThemeStore();
  const [isOpen, setIsOpen] = useState(false);

  const header = (
    <HStack justifyContent="between" className="w-full" onClick={() => setIsOpen(!isOpen)}>
      <TitleSetting icon={<QuestionCircleIcon isDarkMode={isDarkMode} />} label={t(settingLabels.help)} />
    </HStack>
  );
  return (
    <Accordion header={header} isOpen={isOpen} onToggleOpen={() => setIsOpen(!isOpen)}>
      {isOpen ? <HelpSettingContent /> : null}
    </Accordion>
  );
};

export default HelpSetting;

const HelpSettingContent = () => {
  const { t } = useTranslation();
  const { getCurrentPlatform } = usePlatform();
  const { helpUrlForOutLookAddin } = useAppConfigStore();
  // console.log("helpUrlForOutLookAddin >>> ", helpUrlForOutLookAddin);

  const openSupportSite = useCallback(() => {
    const currentPlatform = getCurrentPlatform();
    const supportUrl = helpUrlForOutLookAddin;
    if (currentPlatform === WebAddinPlatforms.OWA) {
      window.open(supportUrl, "_blank");
    } else {
      handleOpenDialog(supportUrl);
    }
  }, [helpUrlForOutLookAddin]);

  return (
    <div className="w-full p-[2px]">
      <Divider className="my-3" />
      <p className="text-xs mb-3">{t("Click on Further information to visit our support site")} </p>

      <HStack justifyContent="end" className="w-full">
        <Button
          isDefault={true}
          label={t("Further information")}
          className="px-6 py-[6px] text-xs"
          onClick={openSupportSite}
          disabled={!helpUrlForOutLookAddin}
        />
      </HStack>
    </div>
  );
};
